<template>
    <div></div>
</template>

<script>
export default {
  name: 'PageLogoutComponent',
  mounted () {
    this.$ls.clear()
    window.location.reload(true)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PageLogoutComponent.vue